import { UPDATE_TASK_SUCCESS } from "../Task/actionTypes";
import { DASHBOARD, DASHBOARD_FAILED, DASHBOARD_SUCCESS } from "./actionTypes";

let initialState = {
  dashboardData: {},
  loading: false,
  success: false,
  error: "",
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD:
      return {
        ...state,
        dashboardData: {},
        loading: true,
        success: false,
        error: "",
      };
    case DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboardData: action.payload,
        loading: false,
        success: true,
        error: "",
      };
    case DASHBOARD_FAILED:
      return {
        ...state,
        dashboardData: {},
        loading: false,
        success: false,
        error: action.payload,
      };

    case UPDATE_TASK_SUCCESS: {
      console.log('====================================');
      console.log("in update task success");
      console.log('====================================');
      const updateTasks = (tasks = []) =>
        tasks.map(item => {
          if (item.task_id !== action.payload.task_id) return item;

          const updatedTimerMap = item?.taskUserMap?.taskTimerMap
            ? [...item.taskUserMap.taskTimerMap]
            : [];

          const existingIndex = updatedTimerMap.findIndex(
            timer => timer.id === action.payload.id
          );

          if (existingIndex !== -1) {
            updatedTimerMap[existingIndex] = action.payload;
          } else {
            updatedTimerMap.push(action.payload);
          }

          return {
            ...item,
            taskUserMap: {
              ...item.taskUserMap,
              taskTimerMap: updatedTimerMap,
            },
          };
        });

      const updatedTasks = updateTasks(state.dashboardData.allTasks);
      const user = JSON.parse(localStorage.getItem('user'));

      const updatedFilteredTasks = updatedTasks.flatMap(task =>
        task.taskUserMap?.taskTimerMap?.filter(timer =>
          user?.id == action.payload.employee_id && timer?.state != "stopped" && timer.task_id == action.payload.task_id
        ) || []
      );
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          allTasks: updatedTasks,
          filteredtask: updatedFilteredTasks
        },
        loading: false,
        success: true,
        error: "",
      };
    }

    default:
      return state;
  }
};
